import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

const ServiceCard = ({ id, name, description, address, image, category, isAdmin, onDelete }) => {
  const navigate = useNavigate();  // This provides the navigate function

  const handleNavigate = (e) => {
    // Don't navigate if clicking on delete button
    if (e.target.closest('.admin-action-button')) {
      return;
    }
    navigate(`/service/${id}`);  // Navigate using the document ID
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(id, name);
    }
  };

  const truncateDescription = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',  // Reduced to 2 lines for mobile
    WebkitBoxOrient: 'vertical'
  };

  const cardStyle = {
    minHeight: '250px',  // Changed from fixed height to minimum height
    height: 'auto'       // Allow height to grow as needed
  };

  const imageStyle = {
    height: '180px',     // Slightly reduced height
    width: '100%',
    objectFit: 'cover'
  };

  return (
    <div className="card property_list" onClick={handleNavigate} style={{...cardStyle, position: 'relative'}}>
      {isAdmin && (
        <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}>
          <Button
            className="admin-action-button"
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={handleDelete}
            size="small"
          >
            Delete
          </Button>
        </div>
      )}
      <div className="body">
        <div className="row g-0">  {/* Added g-0 to remove gutters */}
          <div className="col-lg-4 col-md-6 col-sm-12">  {/* Added col-sm-12 for full width on mobile */}
            <div className="property_image">
              <img className="img-thumbnail img-fluid" src={image} alt="Service" style={imageStyle} />
            </div>
          </div>
          <div className="col-lg-8 col-md-6 col-sm-12 p-3">  {/* Added padding and col-sm-12 */}
            <div className="property-content">
              <div className="detail">
                <h4 className="mt-0 mb-2"><div className="col-blue-grey">{name}</div></h4>
                <p className="text-muted mb-2"><i className="zmdi zmdi-pin me-2" />{address}</p>
                <p className="text-muted mb-2" style={truncateDescription}>{description}</p>
              </div>
              <div className="property-action">
                {category.map((element, index) => (
                  <span key={index} title={element} className="me-2">
                    <i className="zmdi zmdi-star me-1" />{element}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
